import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledWrapper = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  alignContent: 'center',
  flex: '1 1 auto',
  flexWrap: 'nowrap',
  justifyContent: 'center',
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(2.5),
  maxHeight: '100%',
  maxWidth: 'calc(100% - 30px)',
  minWidth: 0,
  overflowX: 'auto',
  overflowY: 'hidden',
}));

export default StyledWrapper;
